<template>
  <div class="d-flex align-items-center min-vh-100 login-container">
    <b-container>
      <b-row class="justify-content-center">
        <b-col md="9" lg="6" class="login">
          <b-card-group>
            <b-card class="p-4 shadow-lg">
              <b-card-body class="login-box">
                <b-form>
                  <div class="text-center img-logo-cover">
                    <!-- <img src="/logo.png" alt /> -->
                    <div
                      class="imgLogo"
                      v-bind:style="{
                        'background-image': 'url(' + imgLogo + ')',
                      }"
                    ></div>
                    <hr class="my-4" />
                  </div>
                  <InputText
                    class="my-3 login-input"
                    v-model="form.Username"
                    textFloat="Username"
                    placeholder="ชื่อผู้ใช้งาน"
                    type="email"
                    name="email"
                    isRequired
                    :isValidate="$v.form.Username.$error"
                    :v="$v.form.Username"
                    @onKeyup="submitFormOnInput"
                  />
                  <InputText
                    class="my-3 login-input"
                    v-model="form.Password"
                    textFloat="Password"
                    placeholder="รหัสผ่าน"
                    type="password"
                    name="password"
                    isRequired
                    :isValidate="$v.form.Password.$error"
                    :v="$v.form.Password"
                    @onKeyup="submitFormOnInput"
                    isShowPassword
                  />
                  <b-row v-if="error != ''" class="m-2 text-center">
                    <span class="text-danger w-100">
                      {{ error }}
                      <br />
                      {{ " " }}
                    </span>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button
                        type="button"
                        class="px-4 login-btn"
                        @click="checkForm"
                        :disabled="isDisable"
                        >เข้าสู่ระบบ
                        <b-spinner
                          class="align-middle w-1rem"
                          v-if="isLogin"
                        ></b-spinner
                      ></b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>

    <ModalComingSoon ref="modalComingSoon" />
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import ModalComingSoon from "@/components/modal/alert/ModalComingSoon";
import imgLogo from "@/assets/images/logo.svg";

export default {
  name: "Login",
  components: {
    InputText,
    ModalComingSoon,
  },
  data() {
    return {
      imgLogo: imgLogo,
      error: "",
      form: {
        Username: "",
        Password: "",
      },
      isLoading: false,
      isDisable: false,
      isLogin: false,
      passwordType: "",
    };
  },
  validations() {
    return {
      form: {
        Username: { required, email },
        Password: { required },
      },
    };
  },
  mounted: async function() {},
  created() {},
  methods: {
    checkForm: async function() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;
      this.isDisable = true;
      this.isLogin = true;
      this.error = "";
      // this.axios.post(`https://api-dev-brandadmin.dosetech.co/api/login`, this.form).then((data) => {
      this.axios
        .post(`${this.$baseUrl}/account/login`, this.form)
        .then((data) => {
          this.isDisable = false;
          if (data.result == 1) {
            this.isLoading = false;
            this.isDisable = false;
            this.isLogin = false;
            var timestamp = new Date().getTime();
            this.$cookies.set("tnl-timestamp", timestamp);
            this.$store.dispatch("setTimestamp", timestamp);
            // this.$cookies.set("tnl-username", data.detail.userDetail.email);
            this.$cookies.set("tnl-username", this.form.Username);
            this.$cookies.set("tnl-session-token", `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUwNDk4ODZkLTE1NTUtNDJjZS04NTdjLTk3YzNiNTQzYTIwOSIsInJvbGUiOiJDaGF0IGFuZCBTaG9wIiwiU3RhZmZJZCI6IjYiLCJuYmYiOjE2NTMzMTU2ODMsImV4cCI6MTY2MTI2NDQ4MywiaWF0IjoxNjUzMzE1NjgzfQ.pyYBPMgUBFki1nBTLAjZNz94jQq4zL-1-UcqRHj63gI`);
            window.location.href = "/";
          } else {
            this.isLoading = false;
            this.isLogin = false;
            this.error = data.message;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    submitFormOnInput: function(e) {
      if (e.keyCode === 13) {
        this.checkForm();
      }
    },
    handleShowHidePassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
  },
};
</script>

<style scoped>
.w-1rem {
  width: 1rem;
  height: 1rem;
}

.button-eye {
  position: absolute;
  right: 10px;
  top: 0.8rem;
  z-index: 6;
}
</style>
